export enum TimeRelativeTo {
    StartTime = "StartTime",
    EndTime = "EndTime",
    ZeroTime = "ZeroTime"
}